import { NameDto } from '../Common/Types'

export interface PromoMaterialsOptionsDto {
  sizes: PromoMaterialSizeDto[]
  categories: NameDto[]
  types: NameDto[]
  baseUrls: NameDto[]
}

export interface PromoMaterialSizeDto {
  id: number
  name: string | null
  width: string | null
  height: string | null
}

export const getBaseUrlName =
  (baseUrls: NameDto[] = []) =>
  (baseUrlDto: NameDto) => {
    const baseUrl = baseUrls.find((x) => x.id === baseUrlDto.id)
    return baseUrl?.name || ''
  }

export enum PromoMaterialType {
  Animated = 1,
  Static = 2,
  HTML5 = 3,
}
